import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { injectStore } from './api/axios'
import App from './App'
import { persistor, store } from './app/store'
import { AuthProvider } from './context/AuthProvider'
import { fetchMenus } from './features/portal/menusSlice'
import { fetchPortal } from './features/portal/portalSlice'
import './index.scss'

import { CustomThemeProvider } from 'common/providers/CustomThemeProvider'

injectStore(store)

store.dispatch(fetchPortal())
store.dispatch(fetchMenus())

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CustomThemeProvider>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </CustomThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
)
